import React, { Fragment } from 'react'
import { FieldRenderProps } from 'react-final-form'
import TextField from '@material-ui/core/TextField'
import MuiAutocomplete from '@material-ui/lab/Autocomplete'
import { useErrors } from 'hooks'

interface AutocompleteProps extends FieldRenderProps<any, HTMLElement> {
  options: Array<{ label: string; value: unknown }>
}

const defaultValue = { label: 'Selecione', value: '' }

const Autocomplete = ({ input, meta, options, label, ...rest }: AutocompleteProps) => {
  const { getFieldError } = useErrors()

  const fieldError = getFieldError(input.name)
  const errorText = meta.error || fieldError || ''

  const value = options.find((option) => option.value === input.value) || defaultValue

  return (
    <MuiAutocomplete
      options={[defaultValue, ...options]}
      value={value}
      onChange={(_, selectedOption) => {
        input.onChange(selectedOption?.value || '')
      }}
      onFocus={input.onFocus}
      onBlur={input.onBlur}
      getOptionLabel={(option) => option.label || ''}
      closeIcon={<Fragment />}
      renderInput={(params) => (
        <TextField
          {...params}
          name={input.name}
          label={label}
          helperText={meta.touched ? errorText : ''}
          error={meta.touched && Boolean(errorText)}
          InputLabelProps={{ shrink: true }}
          size='small'
        />
      )}
      noOptionsText='Não encontrado'
      fullWidth
      {...rest}
    />
  )
}

export default Autocomplete
